export const dayCareExpensesContext = {
    address:"",
    amountPaid:"",
    childrenCaredFor:"",
    einssn:"",
    provider:"",
}